var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.stats)?_c('StandardChart',{attrs:{"input":_vm.chartData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }